import { Bundle, BundleOwner, Subscription } from '@prisma/client';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';

export const useSubscriptionPermissions = () => {
  const { user } = Auth.useUserAuth();

  const canBulkSubscribe = (record: Subscription & { bundle: Bundle & { owners?: BundleOwner[] } }) =>
    user?.id && (user?.roles[Role.SYSTEM_ADMIN] || !!record.bundle.owners?.some((owner) => owner.ownerId === user.id));

  const canEdit = (record: Subscription & { bundle: Bundle & { owners?: BundleOwner[] } }) =>
    user?.id &&
    ([record.userId, record.createdBy].includes(user.id) ||
      user?.roles[Role.SYSTEM_ADMIN] ||
      record.bundle.owners?.some((owner) => owner.ownerId === user.id));

  // using the same access check as the controller method libs/bundle/services/src/lib/subscription/api/controller.ts (retryAccess)
  const canRetryAccess = (subscription: Subscription) =>
    user?.id && ([subscription.userId, subscription.createdBy].includes(user.id) || user.roles[Role.BUNDLE_ADMIN]);

  return { user, canBulkSubscribe, canEdit, canRetryAccess };
};
